import Vue from 'vue'
import Vuex from 'vuex'
import ui from '@/store/ui'
import auth from '@/store/auth'
import regions from '@/store/regions'
import cities from '@/store/cities'
import districts from '@/store/districts'
import boardtypes from '@/store/boardtypes'
import boardsides from '@/store/boardsides'
import boards from '@/store/boards'
import boardsview from '@/store/boardsview'
import clients from '@/store/clients'
import visuals from '@/store/visuals'
import baskets from '@/store/baskets'
import campaigns from '@/store/campaigns'
import displays from '@/store/displays'
import pendingdisplays from '@/store/pendingdisplays'
import offdisplays from '@/store/offdisplays'
import faces from '@/store/faces'
import faceslist from '@/store/faceslist'
import futurview from '@/store/futurview'
import available from '@/store/available'
import printtypes from '@/store/printtypes'
import statuses from '@/store/statuses'
import bookings from '@/store/bookings'
import bookingsview from '@/store/bookingsview'
import incidenttypes from '@/store/incidenttypes'
import interventiontypes from '@/store/interventiontypes'
import users from '@/store/users'
import incidents from '@/store/incidents'
import roles from '@/store/roles'
import stats from '@/store/stats'
import statsdisplayregions from '@/store/statsdisplayregions'
import statsdisplayprints from '@/store/statsdisplayprints'
import statsincidentregions from '@/store/statsincidentregions'
import statsincidentusers from '@/store/statsincidentusers'
import tenancy from '@/store/tenancy'
import notifications from '@/store/notifications'
import newnotifications from '@/store/newnotifications'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    ui,
    auth,
    regions,
    cities,
    districts,
    boardtypes,
    boardsides,
    boards,
    boardsview,
    clients,
    visuals,
    baskets,
    campaigns,
    faces,
    faceslist,
    futurview,
    printtypes,
    statuses,
    displays,
    pendingdisplays,
    offdisplays,
    bookings,
    bookingsview,
    users,
    incidenttypes,
    interventiontypes,
    incidents,
    roles,
    stats,
    available,
    tenancy,
    statsdisplayregions,
    statsdisplayprints,
    statsincidentregions,
    statsincidentusers,
    notifications,
    newnotifications,
  },

  strict: debug,
})

export default store
